import { api } from './api';

// Article related functions
export const fetchArticles = async () => {
  try {
    const articles = await api.getArticles();
    return articles;
  } catch (error) {
    console.error('Error fetching articles:', error);
    throw error;
  }
};

export const createArticle = async (articleData: any) => {
  try {
    const newArticle = await api.createArticle(articleData);
    return newArticle;
  } catch (error) {
    console.error('Error creating article:', error);
    throw error;
  }
};

export const deleteArticle = async (id: number) => {
  try {
    const result = await api.deleteArticle(id);
    return result;
  } catch (error) {
    console.error('Error deleting article:', error);
    throw error;
  }
};

// Gallery related functions
export const fetchGalleries = async () => {
  try {
    const galleries = await api.getGalleries();
    return galleries;
  } catch (error) {
    console.error('Error fetching galleries:', error);
    throw error;
  }
};

export const createGallery = async (galleryData: any) => {
  try {
    const newGallery = await api.createGallery(galleryData);
    return newGallery;
  } catch (error) {
    console.error('Error creating gallery:', error);
    throw error;
  }
};

export const deleteGallery = async (id: number) => {
  try {
    const result = await api.deleteGallery(id);
    return result;
  } catch (error) {
    console.error('Error deleting gallery:', error);
    throw error;
  }
};

// File upload
export const uploadFiles = async (files: File[]): Promise<{ url: string }[]> => {
  try {
    const result = await api.uploadFiles(files);
    // Transform the response to match the expected type
    return Array.isArray(result.files) 
      ? result.files.map(file => ({ url: file.filePath }))
      : [];
  } catch (error) {
    console.error('Error uploading files:', error);
    throw error;
  }
};
